/**
 * Zight — screen recorder and screenshot app (formerly CloudApp)
 *
 * Declares one web-accessible-resource entry matched to every origin with no
 * `use_dynamic_url`, listing eight UI pages (`camPreview.html`, `controls.html`,
 * `screenshot.html`, `pip-interstitial.html`, and others). There are no image WAR, so
 * detection is by fetching a page.
 *
 * `camPreview.html` is the primary signal — a distinctively named page exposed at a fixed
 * URL — corroborated by `pip-interstitial.html` and `screenshot.html`. All resolve only
 * when the extension is installed.
 *
 * Manifest verified against version 8.7.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ojnikmlgjpfiogeijjkpeakbedjhjcch';

export const zight: ExtensionDefinition = {
  id: ID,
  name: 'Zight Screen Recorder, Screenshot App',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 80_000,
  notes:
    'One static WAR on every origin exposing eight named HTML pages with no dynamic URL. ' +
    'Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-cam-preview-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch camPreview.html — a named UI page exposed to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'camPreview.html'),
    },
    {
      id: 'war-pip-interstitial-html',
      kind: 'web-accessible-resource',
      description: 'Fetch pip-interstitial.html — the picture-in-picture page, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'pip-interstitial.html'),
    },
    {
      id: 'war-screenshot-html',
      kind: 'web-accessible-resource',
      description: 'Fetch screenshot.html — the screenshot page, a third corroborating path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'screenshot.html'),
    },
  ],
};
